import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import CelebrationModal from '../settings/CelebrationModal';

function CelebrationTest() {
  const [showModal, setShowModal] = useState(false);
  
  // Auto-show modal after a brief delay when component mounts
  useEffect(() => {
    const timer = setTimeout(() => {
      console.log("CelebrationTest: Auto-showing modal");
      setShowModal(true);
    }, 1000);
    
    return () => clearTimeout(timer);
  }, []);
  
  const handleShowModal = () => {
    console.log("CelebrationTest: Manual show modal");
    setShowModal(true);
  };
  
  const handleCloseModal = () => {
    console.log("CelebrationTest: Modal closed");
    setShowModal(false);
  };
  
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-100 p-8">
      <div className="max-w-xl w-full bg-white rounded-xl shadow-lg p-8 mb-8">
        <h1 className="text-3xl font-bold text-orange-600 mb-6">Celebration Modal Test</h1>
        <p className="mb-6 text-gray-700">
          This page tests only the celebration modal component. The modal should appear automatically 
          when this page loads. If it doesn't, use the button below to show it manually.
        </p>
        
        <div className="flex space-x-4 mb-6">
          <button 
            onClick={handleShowModal}
            className="px-6 py-3 bg-orange-500 text-white rounded-lg shadow-lg hover:bg-orange-600 transition-all duration-300"
          >
            Show Modal Manually
          </button>
          
          <Link
            to="/ui-test"
            className="px-6 py-3 bg-gray-500 text-white rounded-lg shadow hover:bg-gray-600 transition-all duration-300"
          >
            Back to Test Home
          </Link>
        </div>
        
        <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4 text-yellow-700">
          <h3 className="font-bold">Debugging Info:</h3>
          <p>Modal state: {showModal ? 'SHOWING' : 'HIDDEN'}</p>
        </div>
      </div>
      
      <CelebrationModal 
        isOpen={showModal}
        onClose={handleCloseModal}
        userName="Test User"
      />
    </div>
  );
}

export default CelebrationTest; 